import _ from 'lodash';
import React from 'react';
import { Checkbox, DataTable, Modal, Select, TextField } from '@shopify/polaris';
import TableHeadingCellWithTooltip from './table-heading-cell-with-tooltip';
import { DIRECTION } from 'src/constants/synonym';
import { withI18n } from '@shopify/react-i18n';
import componentWithSyncWrapper from 'src/components/containers/common/component-with-sync-wrapper';
import { connect } from 'react-redux';

import * as synonymActions from 'src/stores/actions/synonym-actions';
import { prettyText } from 'src/helpers';

const EditSynonymModal = props => {
  const { i18n, open, synonymInput, onClose, reload, updateSynonyms } = props;

  const [synonym, setSynonym] = React.useState({});
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    setSynonym(synonymInput);
  }, [synonymInput]);

  const updateSynonym = (name, value) => setSynonym({ ...synonym, [name]: value });

  const onSave = async () => {
    setSaving(true);
    const newSynonym = {
      ...synonym,
      synonyms: _.map(synonym.synonyms.split(','), text => prettyText(text)),
      biDirection: synonym.biDirection === '<=>'
    };
    await updateSynonyms([newSynonym], 'changeStatus');
    setSaving(false);
    reload();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={i18n.translate('AdminHTML.Synonym.Edit.title')}
      primaryAction={[
        {
          content: i18n.translate('AdminHTML.Common.Action.save'),
          onAction: onSave,
          loading: saving
        }
      ]}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.Common.Action.cancel'),
          onAction: onClose
        }
      ]}>
      <Modal.Section>
        <div className="editSynonymModel">
          <DataTable
            verticalAlign="top"
            columnContentTypes={['text', 'text', 'text']}
            headings={[
              i18n.translate('AdminHTML.Synonym.Synonym.searchTerm'),
              i18n.translate('AdminHTML.Synonym.Synonym.direction'),
              <TableHeadingCellWithTooltip
                heading={i18n.translate('AdminHTML.Synonym.Synonym.synonyms')}
                tooltipContent={i18n.translate('AdminHTML.Synonym.Synonym.synonyms_Tooltip')}
              />
            ]}
            rows={[
              [
                <TextField
                  value={synonym.searchTerm}
                  onChange={text => updateSynonym('searchTerm', text)}
                  placeholder={i18n.translate('AdminHTML.Synonym.Synonym.searchTerm_Placeholder')}
                />,
                <Select
                  options={DIRECTION}
                  value={synonym.biDirection}
                  onChange={value => updateSynonym('biDirection', value)}
                />,
                <TextField
                  value={synonym.synonyms}
                  onChange={text => updateSynonym('synonyms', text)}
                  placeholder={i18n.translate('AdminHTML.Synonym.Synonym.synonyms_Placeholder')}
                />
              ]
            ]}
          />
        </div>
        <Checkbox
          label={i18n.translate('AdminHTML.Synonym.Synonym.suggestionList')}
          checked={synonym.allowSuggestion}
          onChange={() => updateSynonym('allowSuggestion', !synonym.allowSuggestion)}
        />
      </Modal.Section>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSynonyms: (synonyms, actionName) =>
    dispatch(synonymActions.updateSynonyms(synonyms, actionName, ownProps.i18n))
});

export default componentWithSyncWrapper(
  withI18n()(connect(null, mapDispatchToProps)(EditSynonymModal)),
  'ManualSynonymSetting'
);
